// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * Standard success response for mutations (POST/PUT/DELETE).
 */
export class MutationResponse implements flatbuffers.IUnpackableObject<MutationResponseT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): MutationResponse {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsMutationResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: MutationResponse,
  ): MutationResponse {
    return (obj || new MutationResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsMutationResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: MutationResponse,
  ): MutationResponse {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new MutationResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  success(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  message(): string | null;
  message(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  message(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Row/record count for mutations that affect more than one row
   * (e.g. DELETE /wizard-drafts/:orgId, which deletes every ACTIVE
   * draft for an org). Absent/zero for the common single-row case.
   *
   * Appended at the end of the table to preserve `FlatBuffer` wire
   * compatibility — never insert fields in the middle.
   */
  count(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readInt64(this.bb_pos + offset) : 0n;
  }

  static startMutationResponse(builder: flatbuffers.Builder) {
    builder.startObject(3);
  }

  static addSuccess(builder: flatbuffers.Builder, success: boolean) {
    builder.addFieldInt8(0, +success, +true);
  }

  static addMessage(builder: flatbuffers.Builder, messageOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, messageOffset, 0);
  }

  static addCount(builder: flatbuffers.Builder, count: bigint) {
    builder.addFieldInt64(2, count, 0n);
  }

  static endMutationResponse(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createMutationResponse(
    builder: flatbuffers.Builder,
    success: boolean,
    messageOffset: flatbuffers.Offset,
    count: bigint,
  ): flatbuffers.Offset {
    MutationResponse.startMutationResponse(builder);
    MutationResponse.addSuccess(builder, success);
    MutationResponse.addMessage(builder, messageOffset);
    MutationResponse.addCount(builder, count);
    return MutationResponse.endMutationResponse(builder);
  }

  unpack(): MutationResponseT {
    return new MutationResponseT(this.success(), this.message(), this.count());
  }

  unpackTo(_o: MutationResponseT): void {
    _o.success = this.success();
    _o.message = this.message();
    _o.count = this.count();
  }

  unpackFields(...fields: string[]): MutationResponseT {
    const t = new MutationResponseT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("success")) {
      t.success = this.success();
    }
    if (fieldSet.has("message")) {
      t.message = this.message();
    }
    if (fieldSet.has("count")) {
      t.count = this.count();
    }
    return t;
  }
}

export class MutationResponseT implements flatbuffers.IGeneratedObject {
  constructor(
    public success: boolean = true,
    public message: string | Uint8Array | null = null,
    public count: bigint = 0n,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const message = this.message !== null ? builder.createString(this.message!) : 0;

    return MutationResponse.createMutationResponse(builder, this.success, message, this.count);
  }

  clone(): MutationResponseT {
    const obj = new MutationResponseT();
    obj.success = this.success;
    obj.message = this.message;
    obj.count = this.count;
    return obj;
  }

  equals(other: MutationResponseT): boolean {
    if (this.success !== other.success) return false;
    if (this.message !== other.message) return false;
    if (this.count !== other.count) return false;
    return true;
  }
}

export function verifyMutationResponse(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 8, 8);
  } finally {
    verifier.popDepth();
  }
}
